module.exports = __webpack_public_path__ + "static/media/List-App-Mobile-X-3.8be5688c.png";